import { Navigate } from 'react-router-dom';

/** Hub raíz: entra al módulo S&OP (plan de demanda). */
export function DemandPlanningHomePage() {
  return <Navigate to="/demand-planning/sop/plan" replace />;
}
